window.app = window.app || {};

window.app.featuredTeam = {
  el: {
    sectionHeader: document.querySelector('.mt-featured-team__header'),
    carousel: document.querySelector('.mt-featured-team .swiper'),
    peopleCards: document.querySelectorAll('.mt-ft-person')
  },
  slider: null,

  init: function() {
    const _this = this;
    if (!_this.el.carousel) return;

    const sliderConfig = {
        slidesPerView: 1,
        spaceBetween: 12,
        centeredSlides: true,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          600: {
            slidesPerView: 2,
            spaceBetween: 18,
            centeredSlides: false
          }
        }
    };
    const updateSlider = () => {
        if (window.innerWidth <= 992) {
            if (_this.slider !== null) return;
            _this.slider = new Swiper(_this.el.carousel, sliderConfig);
        } else {
            _this.slider && _this.slider.destroy(true, true);
            _this.slider = null;
        }
    }; 
    updateSlider();
    window.addEventListener('resize', updateSlider);

    // People
    const updatePeopleCards = () => {
      _this.el.peopleCards.forEach(card => {
        const visibleElements = card.querySelectorAll('.mt-ft-person__title, .mt-ft-person__subtitle');
        let offset = (window.innerWidth > 1360) ? 44 : 34;

        visibleElements.forEach(el => {
          offset += el.offsetHeight;
        });

        card.style.setProperty('--content-offset', `${offset}px`);
      });
    };
    _this.el.peopleCards.forEach(card => {
      const trainer = card.querySelector('.mt-ft-person__title');

      card.addEventListener('click', e => {
        if (e.target.tagName === 'A' || window.innerWidth >= 768) return;

        e.preventDefault();
        card.classList.toggle('active');
        if (card.classList.contains('active')) {
          _this.el.peopleCards.forEach(c => c !== card && (c.classList.remove('active')));
        }
      });

      // Additional DL event
      card.addEventListener('mouseenter', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'hover_click',
          link_text: trainer.innerText,
          location: _this.el.sectionHeader.innerText
        });
      }, { once: true });
    });

    updatePeopleCards();
    window.addEventListener('resize', () => {
      updatePeopleCards();
      (window.innerWidth >= 768) && _this.el.peopleCards.forEach(c => c.classList.remove('active'));
    });
  }
}
window.app.featuredTeam.init();